// extracted by mini-css-extract-plugin
export default {"form":"RelatorioFaturamento_form__eamNk","areaBtn":"RelatorioFaturamento_areaBtn__bbKhp","btn":"RelatorioFaturamento_btn__5T125","btn2":"RelatorioFaturamento_btn2__mgDJj"};